import React, { useEffect, useState, useMemo, useRef } from 'react';
import SkillCard from './skill-card';
import Lottie from 'lottie-web';
import Rope from '../animation-json/learning-path.json';
import RopePortriat from '../animation-json/rope-portrait.json';
import NextGrade from '../animation-json/next-grade.json';
import * as S from './question-outcome-style';
import * as SS from '../styles/shared-styles';
import { nextGradeMap } from '../../../constant-data/splashverse-onboarding';
import { IsElaAvailabeForGrade } from '../helper/helper';
import useResize from '../../loggedout/custom-hooks/resize';
import { useDispatch, useSelector } from 'react-redux'
import { setSVOnboardingEventParams, setSelectedSubject } from '../../../stores/splashverse-onboarding/actions';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '../../../utils/responsive_utilities';
import { isMobileDevice } from '../../../utils/web-helper';
import {deepCoveDark, white} from '../../loggedout/shared-styles/Colors'
import { SetActiveCourse } from '../../../services/student-api';
import i18n from '../../../utils/i18n';
import { isDRSWithCategoryExpansion } from '../../../utils/feature_mapping';

const QuestionResult = ({
  setHeadingTransition,
  goToNextHandler,
  setHeadingText,
  doHeaderTransition,
  selectedSubject
}) => {

  const [buildLearningPath, setBuildLearningPath] = useState(false);
  const [fixedWidth, setFixedWidth] = useState(false);
  const [ctaTransition, setCtaTransition] = useState(false);
  const [startTrain, trainHandler] = useState(false);
  const [showLearningPathCta, setShowLearningPathCta] = useState(false);
  const [showCapsules, setShowCapsules] = useState(true);
  const [diffOfPathOutsideViewPort, setDiffOfPathOutsideViewPort] = useState(0);
  const screenSize = useResize().width;
  const screenHeight = useResize().height;

  const { getItem, setValue, deleteAll } = useExtendedLocalStorage('splashverse-onboarding', '');
  const isMobilePortrait = useMediaQuery({ maxWidth: breakpoints.sm - 1, orientation: 'portrait' })
  const isTabletPortrait= useMediaQuery({ minWidth: breakpoints.md, maxWidth: breakpoints.lg - 1, orientation: 'portrait' })
  const isMobileLandscape = useMediaQuery({ minWidth: breakpoints.sm, maxWidth: breakpoints.lg - 1, orientation: 'landscape' })
  const isTabletLandscape = useMediaQuery({minWidth: breakpoints.lg, maxWidth: breakpoints.xl - 1, orientation: 'landscape'})

  const rowWise = isMobilePortrait || isTabletPortrait ? true : false;

  const cardHeight = rowWise ? (isMobilePortrait ? 136 : 150 ) : (isMobileLandscape ? 61 : (isTabletLandscape ? 136 : 125));
  const cardWidth = rowWise ? (isMobilePortrait ? 120 : 124 ) : (isMobileLandscape ? 140: (isTabletLandscape ? 120 : 124));

  const categoryOffset = rowWise ? (isMobilePortrait ? 70 : 85) : 0;
  const learningPathCtaText = isMobileDevice() ? 'See Learning Path' : 'Looks good! See Learning Path';
  const hideFooter = rowWise || isTabletLandscape;

  const {
    childScreenName,
    selectedGrade,
    isPersolizationSkipped,
    gradeCodeMap,
    subjectGradeMap,
    onboardingQuestionOutcome,
    isSecondSubjectPersonalised
  } = useSelector(state => {
    let onboardingQuestionOutcome = selectedSubject === 'math' ?
      state.onboardingQuestionOutcomeMath :
      state.onboardingQuestionOutcomeReading;
    let secondSubjectOutcomes = selectedSubject === 'math' ?
      state.onboardingQuestionOutcomeReading :
      state.onboardingQuestionOutcomeMath;
    let isSecondSubjectPersonalised = secondSubjectOutcomes && secondSubjectOutcomes.length > 1;
    return {
      childScreenName: state.childScreenName,
      selectedGrade: state.selectedGrade,
      isPersolizationSkipped: state.skipPersonalizedToggle,
      subjectCodeMap: state.subjectCodeMap,
      gradeCodeMap: state.gradeCodeMap,
      subjectGradeMap: state.subjectGradeMap,
      onboardingQuestionOutcome,
      isSecondSubjectPersonalised
    }
  });

  const dispatch = useDispatch();

  const countCardsInEachCategory = () => {
    let categoryConcept = 0;
    let categoryPractice = 0;
    onboardingQuestionOutcome?.forEach((val) => {
      if (val.category === 'practice_and_master')
        categoryPractice += 1;
      else
        categoryConcept += 1;
    })
    return { categoryConcept, categoryPractice }
  }
  let totalCardsInEachCategory = useMemo(() => countCardsInEachCategory());

  let wrapperRef = useRef();

  const isAUOrUK = ['en-GB', 'en-AU'].includes(i18n.language);

  const subjectAvailableForPersonalized = {
    code: selectedSubject === "math" ? 'ela' : 'math',
    title: selectedSubject === "math" ? "Reading" : "Math"
  }

  const LoadAnimation = (Json, element, name = '') => {
    Lottie.loadAnimation({
      container: document.getElementById(element),
      animationData: Json,
      loop: false,
      renderer: 'svg',
      name: name,
      rendererSettings: {
        preserveAspectRatio: 'none',
      }
    })
  }

  useEffect(() => {
    setTimeout(() => {
      setCtaTransition(true);
    }, (rowWise ? 5000 : 2200));
    LearningPlanEventsHandler({ name: 'Learning Plan Screen Viewed' });
  }, []);

  useEffect(() => {
    dispatch(setSVOnboardingEventParams({
      interactedFrom: buildLearningPath ? 'Learning Plan Animation Screen Interacted' :'Learning Plan Screen Interacted',
      params: {
        Platform: 'Web',
        Subject: selectedSubject,
        Practice_cards: totalCardsInEachCategory.categoryPractice,
        Concept_cards: totalCardsInEachCategory.categoryConcept,
        Grade: selectedGrade
      }
    }))
    if (buildLearningPath) {
      if(screenSize < 1440) {
        setTimeout(()=>{
          const outsideViewportPortion = rowWise ? (isMobilePortrait ? (1600 - screenHeight) : (1900 - screenHeight)) : (isMobileLandscape ? 1500 - screenSize : 1440-screenSize);
          setDiffOfPathOutsideViewPort(outsideViewportPortion);
        }, rowWise ? 2500 : 1000);

        setTimeout(()=>{
          setDiffOfPathOutsideViewPort(0)},rowWise ? 6500 : 4000);
      }
      setCtaTransition(false);
      setShowLearningPathCta(true);
      LoadAnimation( rowWise ? RopePortriat : Rope, 'rope-wrapper', 'rope');
      LoadAnimation(NextGrade, 'next-grade-wrapper', 'nextGrade');
    }
  }, [buildLearningPath]);

  const calculatePositionOnRowBasis = (index, category, isCapsule, cardHeight, cardWidth, categoryPartition) => {
    let gutterSpace = 16;
    //Each row will have atmost of 2 cards
    let numberOfRowsConcept = Math.ceil(totalCardsInEachCategory.categoryConcept / 2);
    let numberOfRowsPractice = Math.ceil(totalCardsInEachCategory.categoryPractice / 2);
    let categoryPartitionSpace = categoryPartition ? categoryPartition : 108;
    let origin = { x: 0, y: 10 };
    let rowNumber = Math.floor(index / 2);
    let left = 0;
    let top = 0;
    let animationYOffset=0; //offset position that will move the cards up outside the screen
    let delay;
    let delayOffset = 0.25;
    let delayLastColumnOffset = 0.1; //last column delay
    let maxTimeOfPracticeCardRendered = numberOfRowsPractice  * delayOffset;
    let maxTimeOfConceptCardRendered = numberOfRowsConcept * delayOffset;
    let firstPracticeCardTop = ((wrapperRef.current ? wrapperRef.current.offsetHeight : 0) - (numberOfRowsConcept * (gutterSpace + cardHeight) + categoryPartitionSpace + categoryOffset + origin.y))
    let pausePosition; //Value that will pause the cards on the screen for the animation
    let containerWidth = (isTabletPortrait ? 768 : (isMobilePortrait ? 375 : window.innerWidth));

    //setting up origin x with respect to container to align cards in the middle
    origin.x = (containerWidth - (2*cardWidth + gutterSpace))/2;

    if (!isCapsule) {
      origin.y += categoryOffset;

      if (category == "build_concepts") {
        /**
         * Add delayLastColumnOffset with the
         * maximun time of practice row
         * multiplied with the delay offset (it wll give last time of practice row rendered)
         * added with row number in reverse order with the delay
         */
        delay = delayOffset + maxTimeOfPracticeCardRendered + (numberOfRowsConcept - rowNumber) * delayOffset
      }
      else {
        /**
         * In order to achieve the rendering of cards from reverse order
         * (Max row number - current row no.)
         * Multiplied with delay offset
         **/
        delay = (numberOfRowsPractice - rowNumber) * delayOffset;

        /**
         * If there is single card in the practice category
         * set origin in order to align the card in center
         */
        if(totalCardsInEachCategory.categoryPractice == 1){
          origin.x = (containerWidth - cardWidth)/2;
        }
      }
    }

    else {
      if (category == "build_concepts") {
        delay = maxTimeOfConceptCardRendered + maxTimeOfPracticeCardRendered + delayOffset;
      }
      else {
        delay = maxTimeOfPracticeCardRendered + delayOffset;
      }
    }

    if (category == "practice_and_master") {
      /**
       * For practice and master category
       * origin of y will start by adding the
       * card height and gutter space b/w cards of all the build concept rows above
       * and adding the partition space b/w 2 categories
      **/
      origin.y += (numberOfRowsConcept * (gutterSpace + cardHeight) + categoryPartitionSpace);
    }

    //For first row, top position of card would be the origin y
    if (index == 0 || index == 1) {
      top += origin.y;
    }
    /**
     * For rest of the rows,
     * top would be the sum of y origin and
     * card height and gutter space b/w cards of all the build concept rows above
    **/
    else {
      top += (rowNumber * (cardHeight + gutterSpace) + origin.y);
    }

    /**
     * For odd number index(2nd element in each row)
     * left position would be the sum of the width of only card before it and the gutter space
     * top position would be added with 8px to give staggered effect
     */
    if (index % 2) {
      left += origin.x + cardWidth + gutterSpace;
      top += 8;
      delay += delayLastColumnOffset
    }
    /**
     * For even index(1st element of row)
     * left position would start from the origin of x
    **/
    else {
      left += origin.x;
    }

    if (!isCapsule) {
      animationYOffset = cardHeight + top + (wrapperRef.current ? wrapperRef.current.offsetHeight : 0);
      pausePosition = top + cardHeight + firstPracticeCardTop + categoryOffset + gutterSpace;
    }
    else{
      animationYOffset = top + categoryOffset + (wrapperRef.current ? wrapperRef.current.offsetHeight : 0);
      pausePosition = top + (2*categoryOffset) + firstPracticeCardTop + gutterSpace;
    }

    top += 'px';
    left += 'px';

    return { left, top, animationYOffset, delay, pausePosition};
  }

  const calculatePositionOnColumnBasis = (index, category, isCapsule) =>{
    let top = 0;
    let left = 0;
    const initialTop = isMobileLandscape ? 50: 70;
    const skillCardHeight = cardHeight;
    const skillCardWidth = cardWidth;
    const marginGap = isMobileLandscape ? 10 : 16; //8+8 = 16px margin left and right
    const skillCardWidthWithMargin = skillCardWidth + marginGap;
    let halfWidthOfContainer = wrapperRef.current && wrapperRef.current.offsetWidth / 2 || window.innerWidth / 2;
    let numberOfColumnsConcept = Math.ceil(totalCardsInEachCategory.categoryConcept / 2);
    let numberOfColumnsPractice = Math.ceil(totalCardsInEachCategory.categoryPractice / 2);
    let initialPosition = halfWidthOfContainer + (numberOfColumnsConcept - numberOfColumnsPractice) * (skillCardWidthWithMargin/2);
    let gutterSpace = numberOfColumnsConcept && numberOfColumnsPractice ? 25 : 0;

    // If total cards are overflowing the container, then initial position would be accommodating the build concept cards
    if(isMobileLandscape && (((numberOfColumnsConcept + numberOfColumnsPractice)* skillCardWidthWithMargin) + 2*gutterSpace) > ( wrapperRef.current && wrapperRef.current.offsetWidth || window.innerWidth))
      initialPosition = (numberOfColumnsConcept * skillCardWidthWithMargin) + gutterSpace;

    if (category === "practice_and_master") {
      left = initialPosition + gutterSpace + (Math.ceil((index + 1) / 2) - 1) * skillCardWidthWithMargin + 'px';
    } else {
      left = initialPosition - skillCardWidth - gutterSpace - (Math.ceil((index + 1) / 2) - 1) * skillCardWidthWithMargin + (isCapsule ? 25 : 0) + 'px';
    }
    if (index % 2) {
      top = initialTop + skillCardHeight + (Math.ceil((index + 1) / 2)) * marginGap + 'px';
    } else {
      top = initialTop + (Math.ceil((index + 1) / 2) - 1) * marginGap + 'px';
    }
    return { top, left }
  }

  const calculatePosition = (index, category, isCapsule = false) => {
    if(rowWise){
      return calculatePositionOnRowBasis(index, category, isCapsule, cardHeight, cardWidth);
    }
    else{
      return calculatePositionOnColumnBasis(index, category, isCapsule);
    }
  }

  const LearningPlanEventsHandler = (eventData) => {
    const eventProperties = {
      Platform: 'Web',
      Subject: selectedSubject,
      Practice_cards: totalCardsInEachCategory.categoryPractice,
      Concept_cards: totalCardsInEachCategory.categoryConcept,
      Grade: selectedGrade
    }

    const { name, ...rest } = eventData;
    trackAnalyticsEvent(name, { ...eventProperties, ...rest });
  }

  const seeLearningPathHandler = (e) => {
    LearningPlanEventsHandler({
      name: 'Learning Plan Screen Interacted',
      'Clicked On': e.target.text
    });
    setHeadingText(`${childScreenName}’s Learning Path for ${gradeCodeMap.get(selectedGrade).title}`);
    doHeaderTransition();
    setBuildLearningPath(true);
    setFixedWidth(true);
    trackAnalyticsEvent("Learning Plan Animation Screen Viewed", {});
  }

  const proceedToDashboard = async (e) => {
    LearningPlanEventsHandler({
      name: 'Learning Plan Animation Screen Interacted',
      'Clicked On': e.target.text
    });
    setHeadingTransition(true);
    setShowCapsules(false);
    setFixedWidth(false)
    setShowLearningPathCta(false);
    let opt = {deleteAll};
    goToNextHandler(`building_focus_area_${selectedSubject}`,opt);
  }

  const goToPersonaliseSecondSubject = async (e, subjectToBePersonalised) => {
    LearningPlanEventsHandler({
      name: 'Learning Plan Animation Screen Interacted',
      'Clicked On': e.target.text
    });
    setValue('selectedSubject', subjectToBePersonalised);
    dispatch(setSelectedSubject(subjectToBePersonalised));


    SetActiveCourse({ subject_code: subjectToBePersonalised});
    // goToNextHandler(`building_focus_area_${subjectToBePersonalised}`, opt);

    if(isDRSWithCategoryExpansion()){
      const opt = {
        selectedSubject: subjectToBePersonalised,
      };
      goToNextHandler('subject_selection', opt);
    }
    else{
      const opt = {
        goToOnboardingQuestion: true,
        selectedSubject: subjectToBePersonalised,
        code: getItem('selectedPersonalize')
      }
      goToNextHandler('personalize_opt_in_screen', opt); // pass the step that is before the onboarding questions
    }
  }

  const showPersonalisedNextSubjectButton = () => {
    const gradeId = gradeCodeMap.get(selectedGrade).id;
    return !isSecondSubjectPersonalised && IsElaAvailabeForGrade(gradeId, subjectGradeMap);
  }
  return (
    <>
      <S.Wrapper ref={wrapperRef} startTrain={startTrain} widthFixed={fixedWidth} scrollAmount={diffOfPathOutsideViewPort} rowWise = {rowWise} isMobilePortrait={isMobilePortrait} isTabletPortrait={isTabletPortrait} buildLearningPath={buildLearningPath} >
        {(!!totalCardsInEachCategory.categoryConcept && showCapsules) &&
          <S.CategorySection
            removeCapsule={showLearningPathCta}
            getInCenter={!totalCardsInEachCategory.categoryPractice && '50%'}
            sideH={calculatePosition(0, 'build_concepts', true).left}
            sideV={rowWise ? calculatePosition(0, 'build_concepts', true).top : 'unset'}
            animationYOffset = {calculatePosition(0, 'build_concepts', true).animationYOffset}
            delay = {calculatePosition(0, 'build_concepts', true).delay}
            category={'p'}
            rowWise={rowWise}
          >
            <S.CapsuleLabel end={totalCardsInEachCategory.categoryPractice && 'flex-end'} category={'p'} rowWise={rowWise}>Build Concepts</S.CapsuleLabel>
            <S.SectionHeading category={'p'} rowWise={rowWise} isMobilePortrait={isMobilePortrait}>Skills {childScreenName} needs to learn and master</S.SectionHeading>
          </S.CategorySection>}
        {(!!totalCardsInEachCategory.categoryPractice && showCapsules) &&
          <S.CategorySection
            removeCapsule={showLearningPathCta}
            getInCenter={!totalCardsInEachCategory.categoryConcept && '50%'}
            sideH={calculatePosition(0, 'practice_and_master', true).left}
            sideV={rowWise ? calculatePosition(0, 'practice_and_master', true).top : 'unset'}
            animationYOffset = {calculatePosition(0, 'practice_and_master', true).animationYOffset}
            category={'b'}
            delay = {calculatePosition(0, 'practice_and_master', true).delay}
            pausePosition = {calculatePosition(0, 'practice_and_master', true).pausePosition}
            rowWise = {rowWise}
          >
            <S.CapsuleLabel end={totalCardsInEachCategory.categoryConcept && 'flex-start'} category={'b'} rowWise={rowWise}>Practice & Master</S.CapsuleLabel>
            <S.SectionHeading end={'flex-start'} rowWise={rowWise}>Skills {childScreenName} will soon be fluent in</S.SectionHeading>
          </S.CategorySection>}
        <>
          {onboardingQuestionOutcome?.map((val, index) =>
            <SkillCard
              calculatePosition={calculatePosition}
              val={val}
              category={val.category}
              index={index}
              buildLearningPath={buildLearningPath}
              side="left"
              subject={selectedSubject}
              grade={selectedGrade}
              cardHeight = {cardHeight}
              cardWidth = {cardWidth}
              rowWise = {rowWise}
            />
          )}
        </>
        {buildLearningPath && <S.LearningRopeWrapper id="rope-wrapper" rowWise = {rowWise}/>}
        {
          buildLearningPath && <S.CartWrapper subject={selectedSubject} >
            <S.CurrentGrade>
              <S.CurrentGradeText>{gradeCodeMap.get(selectedGrade).title}</S.CurrentGradeText>
            </S.CurrentGrade></S.CartWrapper>
        }
        {buildLearningPath && <><S.NextGradeWrapper id="next-grade-wrapper">
          <S.NextGradeText>{nextGradeMap[selectedGrade]}</S.NextGradeText>
          </S.NextGradeWrapper></>}
      </S.Wrapper>

      <S.StartLearningPath ctaTransition={ctaTransition} rowWise = {rowWise} isMobilePortrait={isMobilePortrait} isTabletPortrait={isTabletPortrait} onClick={(e) => seeLearningPathHandler(e)}>{learningPathCtaText}</S.StartLearningPath>
      {!buildLearningPath && <SS.Footer ctaTransition={ctaTransition} hideFooter={hideFooter}>Feel like a skill isn't placed in the right category for your child? Don't worry, the program will assess and adapt to their learning level
      </SS.Footer>}
      {buildLearningPath && <S.LearningPathCTAWrapper ctaTransition={showLearningPathCta} rowWise = {rowWise}>
        {(showPersonalisedNextSubjectButton() && !isPersolizationSkipped) && !(isAUOrUK && ['3', '4', '5'].includes(selectedGrade)) &&
          <S.LearningPathCTA ctaType="personalise" ctaColor={deepCoveDark} onClick={(e) => goToPersonaliseSecondSubject(e, subjectAvailableForPersonalized.code)}>
            Personalize {subjectAvailableForPersonalized.title}
          </S.LearningPathCTA>
        }
        <S.LearningPathCTA ctaType="start-play" ctaColor={white} onClick={(e) => { proceedToDashboard(e) }}>Continue</S.LearningPathCTA>
      </S.LearningPathCTAWrapper>}
    </>
  )
}

export default QuestionResult;
